import { TFunction } from "i18next";

export * from "./DayViewTable";
export * from "./LocationWithPreview";
export * from "./Modals/DayViewAddPastShiftModal";
export * from "./Modals/PersonnelViewAddPastShiftModal";
export * from "./PersonnelViewTable";

export enum View {
  DayView = 1,
  PersonnelView,
}

export const ViewTypes = (t: TFunction<"ns1", undefined>) => [
  { value: View.DayView, label: t("food.DayView") },
  { value: View.PersonnelView, label: t("food.Personnel View") },
];
